import { Box } from "@mui/material"
import type { FC } from "react"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletUnitsCellProps {
  pallet: GoodsReceiptPallet
}

export const GoodsReceiptPalletUnitsCell: FC<GoodsReceiptPalletUnitsCellProps> = ({ pallet }) => {
  return (
    <Box className='flex flex-col'>
      {pallet.goodsReceiptPalletRow?.lots?.map((lot) => <span key={lot.goodsReceiptPalletRowLotId}>{lot.units}</span>)}
    </Box>
  )
}
